export default "__VITE_ASSET__D1t1hGHI__"